<template>
  <ul class="left-menu">
    <li>
      <a
        href="#"
        class="js-sidebar-open"
        @click="closeMenu()"
      >
        <app-icon
          name="olymp-close-icon"
          color="dark-gray"
          size="normal"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Collapse Menu</span></a>
    </li>

    <li>
      <router-link to="/areas">
        <app-icon-multiple
          name="nico-menu-tickets"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">All Areas</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'all'"
        to="/all/tickets"
      >
        <app-icon-multiple
          name="nico-menu-tickets"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Tickets</span>
      </router-link>
      <a href="#" />
    </li>
    <li>
      <router-link
        v-if="subApp && subApp === 'fin'"
        to="/fin/month/11/2022"
      >
        <app-icon-multiple
          name="nico-menu-tickets"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Financial</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'phy'"
        to="/phy/shopping"
      >
        <app-icon
          name="olymp-shopping-bag-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Shopping</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'phy'"
        to="/phy/health"
      >
        <app-icon
          name="olymp-stats-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Health</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'all'"
        to="/all/life-story-timeline"
      >
        <app-icon-multiple
          name="nico-timeline-icon"
          tooltip="Timeline"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Life Story Timeline</span>
      </router-link>
      <a href="#" />
    </li>
    <!--<li>
      <router-link to="/moments">
        <app-icon-multiple
          name="nico-timeline-icon"
          tooltip="Moments"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Moments</span>
      </router-link>
      <a href="#" />
    </li> -->
    <li>
      <router-link
        v-if="subApp && subApp === 'all'"
        to="/all/articles"
      >
        <app-icon
          name="olymp-newsfeed-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Article</span>
      </router-link>
      <a href="#" />
    </li>




    <li>
      <router-link
        v-if="subApp && subApp === 'voc'"
        to="/voc/books"
      >
        <app-icon-multiple
          name="nico-books-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Books</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'fin'"
        to="/fin/timeline"
      >
        <app-icon-multiple
          name="nico-timeline-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Timeline</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'all'"
        to="/all/links"
      >
        <app-icon-multiple
          name="nico-link-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Links</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'voc'"
        to="/voc/movies"
      >
        <app-icon-multiple
          name="nico-video-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Movies</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'voc'"
        to="/voc/food"
      >
        <app-icon-multiple
          name="nico-food-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Food</span>
      </router-link>
      <a href="#" />
    </li>



    <li>
      <router-link
        v-if="subApp && subApp === 'soc'"
        to="/soc/chat"
      >
        <app-icon-multiple
          name="nico-chat-icon"
          tooltip="Chat"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Chat</span>
      </router-link>
      <a href="#" />
    </li>


    <li>
      <router-link
        v-if="subApp && subApp === 'all'"
        to="/all/quotes"
      >
        <app-icon-multiple
          name="nico-quote-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Quotes</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'voc'"
        to="/voc/songs"
      >
        <app-icon-multiple
          name="olymp-headphones-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Songs</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'voc'"
        to="/voc/nuskinlist"
      >
        <app-icon-multiple
          name="olymp-newsfeed-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">Nu Skin</span>
      </router-link>
      <a href="#" />
    </li>

    <li>
      <router-link
        v-if="subApp && subApp === 'spi'"
        to="/spi/afteridie"
      >
        <app-icon-multiple
          name="nico-timeline-icon"
          tooltip="After I Die"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
        <span class="left-menu-title">After I Die</span>
      </router-link>
      <a href="#" />
    </li>
  </ul>
</template>

<script>
// eslint-disable-next-line
// import Ps from 'perfect-scrollbar';
// eslint-disable-next-line
// import '../../../css/perfect-scrollbar.css';
import AppIconMultiple from '../AppIconMultiple'
import AppIcon from '../AppIcon'

export default {
  name: 'PersonalLarge',
  components: {AppIcon, AppIconMultiple},//
  props: {
    // openMenuVar: {
    //   type: Boolean,
    //   default: false
    // }
  },
  // computed: {
  //   openMenu() {
  //     return this.openMenuVar;
  //   },
  // },
  data () {
    return {
      openMenu: true,
      subApp: '',
    }
  },
  watch: {
    // openMenuVar() {
    //   // this.openMenu = this.openMenuVar;
    //   console.log(this.openMenuVar);
    // },
  },
  mounted() {
    let subApp = this.$route.path.substr(1, 3);
    this.subApp = subApp;
  },
  methods: {
    // getLink (item) {
    //   return `/${this.ppa}/${item}`
    // },
    // getLinkArticle() {
    //   return ['personal', 'nlp'].includes(this.ppa)
    // },
    closeMenu() {
      this.openMenu = !this.openMenu
      this.$emit('openmenu', false);

    }
  },
}
</script>
